import React from 'react';
import { Colors } from 'library';
import { Card, Divider, Icon, PillButton, Stack, Text, Title } from 'library/ui';
import { track } from 'shared';
import { SearchOff } from '@mui/icons-material';

export default function NoWorkersFound({ signUp }: { signUp: () => void }) {
    return (
        <Stack align="center">
            <Card padding="lg">
                <Stack align="center" gap="md" maxWidth="sm">
                    <Icon icon={SearchOff} size="lg" bgColor={Colors.secondarySoft} iconColor={Colors.primary} />
                    <Title size="h2">No teachers found in this area yet</Title>
                    <Text tone="secondary" align="center">
                        We don&apos;t have any available profiles that match your search right now, but new teachers are
                        joining us all the time!
                    </Text>
                    <Divider />
                    <Title size="h2">We&apos;re expanding quickly!</Title>
                    <Text tone="secondary" align="center">
                        Create an account to be notified when new teachers become available in your area.
                    </Text>
                    <PillButton
                        onClick={() => {
                            track('Unsupported Region Customer Clicked Sign Up Button');
                            signUp();
                        }}
                    >
                        Create Free Account
                    </PillButton>
                </Stack>
            </Card>
        </Stack>
    );
}
